import { RecentlyViewed } from '@theme/recently-viewed-products';
class QuickViewCard extends HTMLElement {
  constructor() {
    super();
    this.partition = Number(this.getAttribute("data-partition"));
    this.cache = {};
    this.MATCHMEDIA = window.matchMedia("(min-width: 749px)");
    this.appender = null;
    this.setAppender(this.MATCHMEDIA.matches);
    this.MATCHMEDIA.addEventListener("change", (e) => {
      this.handleMediaChange(e.matches);
    });
  }

  connectedCallback() {
    this.main();
  }

  handleMediaChange(isDesktop) {
    const prevContent = this.appender ? this.appender.innerHTML : "";
    this.setAppender(isDesktop, prevContent);
  }

  setAppender(isDesktop, previousContent = "") {
    if (isDesktop) {
      const desktopHost = this.querySelector(this.getAttribute("data_host_el"));
      if (desktopHost) {
        desktopHost.innerHTML = previousContent;
        this.appender = desktopHost;
      }
    } 
    else {
      let mobileHost = document.createElement("div");
      mobileHost.classList.add("mobile__view__appender");
      document.body.appendChild(mobileHost);
      mobileHost.innerHTML = previousContent;
      this.appender = mobileHost;
    }
  }

  main() {
    this.handleClick();
    this.hidePopup();
    this.fetchDataAndUpdate();
  }

  async fetchData(url) {
    if (this.cache[url]) return this.cache[url];
    try {
      const res = await fetch(url);
      const data = await res.text();
      this.cache[url] = data;
      return data;
    } catch (err) {
      console.error("Fetch failed:", err);
    }
  }

  handleClick() {
    const btn = this.querySelector(".js__fetch__btn");
    if (!btn) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      if (this.appender) this.appender.classList.add("is-visible");
    });
  }

  hidePopup() {
    document.addEventListener("click", (e) => {
      const button = this.querySelector(".js__fetch__btn");
      if (!button || !this.appender) return;
      if (button.contains(e.target) || this.appender.contains(e.target)) return;
      this.appender.classList.remove("is-visible");
    });
  }

  async fetchDataAndUpdate(url) {
    if (!url) url = this.getAttribute("data-product_link");
    if (!url) return console.error("Missing data-product_link attribute");

    const html = await this.fetchData(url);
    if (!html) return;

    const temp = new DOMParser().parseFromString(html, "text/html");
    const selector = this.getAttribute("data_req_el");
    const config = temp.querySelector(selector);
    if (!config) return console.error(`Invalid selector: ${selector}`);

    this.cloneAndAppend(config);
  }

  cloneAndAppend(config) {
    if (!config || !this.appender) return;

    this.appender.innerHTML = "";
    const partition = this.partition || 1;
    const partials = [];

    for (let i = 1; i <= partition; i++) {
      const partial = document.createElement("div");
      partial.classList.add("dynamic_partial", `partial__${i}`);
      this.appender.appendChild(partial);
      partials.push(partial);
    }

    for (let i = 1; i <= partition; i++) {
      const dataAttr = this.getAttribute(`data_part_${i}`);
      if (dataAttr) {
        const contents = config.querySelectorAll(dataAttr);
        contents.forEach((c) => partials[i - 1].appendChild(c.cloneNode(true)));
      }
    }
  }
}

if (!customElements.get("quick-view-card")) {
  customElements.define("quick-view-card", QuickViewCard);
}

class ProductSwatch extends HTMLElement {
  constructor() {
    super();
    this.quickview = this.closest("quick-view-card");
    this.url = this.querySelector("a")?.getAttribute("href");
    this.product_id = this.getAttribute("data-product-id");
  }

  connectedCallback() {
    this.addEventListener("click", async (e) => {
      e.preventDefault();
      if (this.quickview && this.url) {
        this.quickview.fetchDataAndUpdate(this.url);
      }
      // for product page only
      else{
       // fetch product page
       const handle = this.url.replace("/products/","")
       const res = await fetch(this.url);
       const text = await res.text();

       const html = new DOMParser().parseFromString(text,"text/html");
       // update the recommendations
       const recommendations = document.querySelector("product-recommendations");
       recommendations.setAttribute("data-product-id",this.product_id);
       recommendations.setAttribute("data-recommendations-performed","false");
      // update and reload the recently viewed
       RecentlyViewed.addProduct(handle);
       window.updateRecentView(handle);
      // check as seeonn on section and update 

      const AS_SEEN_ON = html.querySelector("div[section_main_wrapper_as_Seen_on]");
      if(AS_SEEN_ON) {
        document.querySelector(".instragram_wrapper__section_div").innerHTML = AS_SEEN_ON.outerHTML;
        window.fetchAsSeenImages();

      }
      else{
        document.querySelector(".instragram_wrapper__section_div").innerHTML = "";
      }

      // update main product dom
       const easysize_button = document.querySelector("#easysize_button");
       const productContainer = document.querySelector(".data_fetched__and_updated_by_js");
       productContainer.outerHTML = html.querySelector(".data_fetched__and_updated_by_js").outerHTML;
       if(easysize_button) document.querySelector(".data_fetched__and_updated_by_js").appendChild(easysize_button);
       const newUrl = new URL(this.url, window.location.origin);
       window.history.replaceState({}, "", newUrl.toString());
       document.querySelectorAll("popup-component").forEach(el => {
       customElements.upgrade(el);
      });
      window.UpdateMobileQuickView();
      window.updateStickyMobileTemplate();
      const updatedContainer = document.querySelector(".data_fetched__and_updated_by_js");
      if (typeof window.initStickyAddToCart === 'function') {
        window.initStickyAddToCart();
      } else {
        console.warn('initStickyAddToCart is not available.');
      }
      }
    });
  }
}

if (!customElements.get("product-swatch"))
  customElements.define("product-swatch", ProductSwatch);

window.UpdateMobileQuickView = function () {
  const section = document.querySelector('[section_main_wrapper_as_seen_on]');
  const mobileWrapper = document.querySelector(".mobile-instagram");
  const desktopWrapper = document.querySelector(".instragram_wrapper__section_div");

  if (!section || !mobileWrapper || !desktopWrapper) return;

  const screenWidth = window.innerWidth;

  if (screenWidth < 750) {
    if (!mobileWrapper.contains(section)) {
      mobileWrapper.appendChild(section);
    }
  } else {
    if (!desktopWrapper.contains(section)) {
      desktopWrapper.appendChild(section);
    }
  }
};

window.updateStickyMobileTemplate = function () {
  document.querySelectorAll(".product-tabs-component").forEach((component) => {

    const nav = component.querySelector("[data-tabs-nav]");
    const content = component.querySelector("[data-tabs-content]");

    if (!nav || !content) return;

    const items = content.querySelectorAll(".product-tab-item");

    items.forEach((item, index) => {

      const button = item.querySelector(".product-tab-pill");
      const panel = item.querySelector(".product-tab-panel");

      if (!button || !panel) return;

      // Move pills into top nav
      nav.appendChild(button);

      // First active
      if (index === 0) {

        button.classList.add("active");
        button.setAttribute("aria-selected", "true");
        button.setAttribute("tabindex", "0");

        panel.classList.add("active");
        panel.hidden = false;

      } else {

        button.setAttribute("aria-selected", "false");
        button.setAttribute("tabindex", "-1");

        panel.hidden = true;

      }

      button.addEventListener("click", () => {

        const targetId = button.dataset.tabTrigger;

        // Reset buttons
        nav.querySelectorAll(".product-tab-pill").forEach((pill) => {

          pill.classList.remove("active");
          pill.setAttribute("aria-selected", "false");
          pill.setAttribute("tabindex", "-1");

        });

        // Reset panels
        content.querySelectorAll(".product-tab-panel").forEach((tabPanel) => {

          tabPanel.classList.remove("active");
          tabPanel.hidden = true;

        });

        // Active button
        button.classList.add("active");
        button.setAttribute("aria-selected", "true");
        button.setAttribute("tabindex", "0");

        // Active panel
        const activePanel = content.querySelector(`#${targetId}`);

        if (activePanel) {

          activePanel.classList.add("active");
          activePanel.hidden = false;

        }

        // Smooth scroll active pill
        button.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });

      });

      // Keyboard support
      button.addEventListener("keydown", (event) => {

        const tabs = [...nav.querySelectorAll(".product-tab-pill")];

        const currentIndex = tabs.indexOf(button);

        let nextIndex = currentIndex;

        switch (event.key) {

          case "ArrowRight":
            nextIndex = (currentIndex + 1) % tabs.length;
            break;

          case "ArrowLeft":
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;

          case "Home":
            nextIndex = 0;
            break;

          case "End":
            nextIndex = tabs.length - 1;
            break;

          default:
            return;

        }

        event.preventDefault();

        tabs[nextIndex].focus();
        tabs[nextIndex].click();

      });

    });

    // Mouse wheel horizontal scroll
    nav.addEventListener("wheel", (event) => {

      if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {

        event.preventDefault();

        nav.scrollLeft += event.deltaY;

      }

    }, { passive: false });

    component.classList.add("tabs-ready");

  });
};

(function () {
  let resizeTimeout = null;

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      window.UpdateMobileQuickView();
    }, 200);
  });
})();

(function () {
  let resizeTimeout = null;

  window.addEventListener("DOMContentLoaded", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      window.UpdateMobileQuickView();
    }, 200);
  });
})();
